import { EDeviceModel } from '@web/entities/connections/model/enums'
import { EMeasurementType } from '@web/entities/measurement/model/enums/measurement-type.enum'
import {
  ELtr24SamplingRate,
  ESamplingRate
} from '@web/entities/measurement/model/enums/sampling-rate.enum'
import { ETemperatureType } from '@web/entities/measurement/model/enums/temperature.enum'
import { EPhysicalType } from '@web/entities/point'
import type { IOption } from '@web/shared/types/options.type'


export const measurementLabelMap: { [key in EMeasurementType]: string } = {
  [EMeasurementType.SIGNAL]: 'Сигнал',
  [EMeasurementType.SPECTER]: 'Спектр',
  [EMeasurementType.OCTAVE]: 'Долеоктавный спектр',
  [EMeasurementType.ENVELOPE_SPECTER]: 'Спектр огибающей',
  [EMeasurementType.ENVELOPE_SIGNAL]: 'Сигнал огибающей',
  [EMeasurementType.COMMON_LEVEL]: 'Общий уровень',
  [EMeasurementType.TEMPERATURE]: 'Температура',
  [EMeasurementType.RS]: 'Частота вращения',
  [EMeasurementType.RD]: 'Изменение частоты вращения',
  [EMeasurementType.TSR]: 'Сигнал частота вращения',
  [EMeasurementType.TSRD]: 'Сигнал изменение частоты вращения',
  [EMeasurementType.TSTM]: 'Сигнал интервалов'
} as const

export const typesMeasurementOptions: Array<
  IOption<
    EMeasurementType,
    { physicalQuantity: EPhysicalType[]; typeDevice: EDeviceModel[] }
  >
> = [
  {
    label: measurementLabelMap[EMeasurementType.SIGNAL],
    value: EMeasurementType.SIGNAL,
    availableFor: {
      physicalQuantity: [
        EPhysicalType.VIBRO_ACCELERATION,
        EPhysicalType.VIBRO_DISPLACEMENT,
        EPhysicalType.VIBRO_VELOCITY,
        EPhysicalType.AMPERAGE,
        EPhysicalType.VOLTAGE
      ],
      typeDevice: [
        EDeviceModel.LTR24,
        EDeviceModel.VP3701,
        EDeviceModel.GENERATOR
      ]
    }
  },
  {
    label: measurementLabelMap[EMeasurementType.SPECTER],
    value: EMeasurementType.SPECTER,
    availableFor: {
      physicalQuantity: [
        EPhysicalType.VIBRO_ACCELERATION,
        EPhysicalType.VIBRO_VELOCITY,
        EPhysicalType.VIBRO_DISPLACEMENT,
        EPhysicalType.AMPERAGE,
        EPhysicalType.VOLTAGE
      ],
      typeDevice: [
        EDeviceModel.LTR24,
        EDeviceModel.VP3701,
        EDeviceModel.GENERATOR
      ]
    }
  },
  {
    label: measurementLabelMap[EMeasurementType.COMMON_LEVEL],
    value: EMeasurementType.COMMON_LEVEL,
    availableFor: {
      physicalQuantity: [
        EPhysicalType.VIBRO_ACCELERATION,
        EPhysicalType.AMPERAGE,
        EPhysicalType.VIBRO_VELOCITY,
        EPhysicalType.VOLTAGE,
        EPhysicalType.VIBRO_DISPLACEMENT
      ],
      typeDevice: [
        EDeviceModel.LTR24,
        EDeviceModel.VP3701,
        EDeviceModel.GENERATOR
      ]
    }
  },
  {
    label: measurementLabelMap[EMeasurementType.TEMPERATURE],
    value: EMeasurementType.TEMPERATURE,
    availableFor: {
      physicalQuantity: [EPhysicalType.TEMPERATURE],
      typeDevice: [EDeviceModel.VP3701, EDeviceModel.GENERATOR, EDeviceModel.CONTROLLER]
    }
  },
  {
    label: measurementLabelMap[EMeasurementType.RS],
    value: EMeasurementType.RS,
    availableFor: {
      physicalQuantity: [EPhysicalType.RPM],
      typeDevice: [
        EDeviceModel.LTR51,
        EDeviceModel.LTR_SYNC,
        EDeviceModel.GENERATOR
      ]
    }
  },
  {
    label: measurementLabelMap[EMeasurementType.RD],
    value: EMeasurementType.RD,
    availableFor: {
      physicalQuantity: [EPhysicalType.RPM],
      typeDevice: [
        EDeviceModel.LTR51,
        EDeviceModel.LTR_SYNC,
        EDeviceModel.GENERATOR
      ]
    }
  },
  {
    label: measurementLabelMap[EMeasurementType.TSR],
    value: EMeasurementType.TSR,
    availableFor: {
      physicalQuantity: [EPhysicalType.RPM],
      typeDevice: [EDeviceModel.LTR_SYNC, EDeviceModel.GENERATOR]
    }
  },
  {
    label: measurementLabelMap[EMeasurementType.TSRD],
    value: EMeasurementType.TSRD,
    availableFor: {
      physicalQuantity: [EPhysicalType.RPM],
      typeDevice: [EDeviceModel.LTR_SYNC, EDeviceModel.GENERATOR]
    }
  },
  {
    label: measurementLabelMap[EMeasurementType.TSTM],
    value: EMeasurementType.TSTM,
    availableFor: {
      physicalQuantity: [EPhysicalType.RPM],
      typeDevice: [EDeviceModel.LTR_SYNC, EDeviceModel.GENERATOR]
    }
  },
  {
    label: measurementLabelMap[EMeasurementType.OCTAVE],
    value: EMeasurementType.OCTAVE,
    availableFor: {
      physicalQuantity: [
        EPhysicalType.VIBRO_ACCELERATION,
        EPhysicalType.VIBRO_VELOCITY,
        EPhysicalType.VIBRO_DISPLACEMENT,
        EPhysicalType.AMPERAGE,
        EPhysicalType.VOLTAGE
      ],
      typeDevice: [
        EDeviceModel.LTR24,
        EDeviceModel.VP3701,
        EDeviceModel.GENERATOR
      ]
    }
  },
  {
    label: measurementLabelMap[EMeasurementType.ENVELOPE_SPECTER],
    value: EMeasurementType.ENVELOPE_SPECTER,
    availableFor: {
      physicalQuantity: [
        EPhysicalType.VIBRO_ACCELERATION,
        EPhysicalType.AMPERAGE,
        EPhysicalType.VOLTAGE
      ],
      typeDevice: [
        EDeviceModel.LTR24,
        EDeviceModel.VP3701,
        EDeviceModel.GENERATOR
      ]
    }
  },
  {
    label: measurementLabelMap[EMeasurementType.ENVELOPE_SIGNAL],
    value: EMeasurementType.ENVELOPE_SIGNAL,
    availableFor: {
      physicalQuantity: [
        EPhysicalType.VIBRO_ACCELERATION,
        EPhysicalType.AMPERAGE,
        EPhysicalType.VOLTAGE
      ],
      typeDevice: [
        EDeviceModel.LTR24,
        EDeviceModel.VP3701,
        EDeviceModel.GENERATOR
      ]
    }
  }
]

export const samplingRateLtr24Options = [
  {
    label: '117 000',
    value: ELtr24SamplingRate.LTR24_FREQ_117K,
    disabled: true
  },
  { label: '58 000', value: ELtr24SamplingRate.LTR24_FREQ_58K },
  { label: '29 000', value: ELtr24SamplingRate.LTR24_FREQ_29K },
  { label: '14 000', value: ELtr24SamplingRate.LTR24_FREQ_14K },
  { label: '7 300', value: ELtr24SamplingRate.LTR24_FREQ_7K3 },
  { label: '3 600', value: ELtr24SamplingRate.LTR24_FREQ_3K6 },
  { label: '1 800', value: ELtr24SamplingRate.LTR24_FREQ_1K8 },
  { label: '915', value: ELtr24SamplingRate.LTR24_FREQ_915 }
]

export const temperatureTypeMap = {
  [ETemperatureType.OBJECT]: 'Объект',
  [ETemperatureType.SENSOR]: 'Датчик'
}

export const temperatureTypeOptions = [
  {
    value: ETemperatureType.OBJECT,
    label: temperatureTypeMap[ETemperatureType.OBJECT]
  },
  {
    value: ETemperatureType.SENSOR,
    label: temperatureTypeMap[ETemperatureType.SENSOR]
  }
]

export const samplingRateLtr24Map: {
  [KEY_MAP in ELtr24SamplingRate]: number
} = {
  [ELtr24SamplingRate.LTR24_FREQ_117K]: 117_000,
  [ELtr24SamplingRate.LTR24_FREQ_58K]: 58_000,
  [ELtr24SamplingRate.LTR24_FREQ_29K]: 29_000,
  [ELtr24SamplingRate.LTR24_FREQ_14K]: 14_000,
  [ELtr24SamplingRate.LTR24_FREQ_7K3]: 7_300,
  [ELtr24SamplingRate.LTR24_FREQ_3K6]: 3_600,
  [ELtr24SamplingRate.LTR24_FREQ_1K8]: 1_800,
  [ELtr24SamplingRate.LTR24_FREQ_915]: 915
}

export const samplingRateMap: { [KEY_MAP in ESamplingRate]: number } = {
  [ESamplingRate.RATE_17_102400]: 102_400,
  [ESamplingRate.RATE_16_51200]: 51_200,
  [ESamplingRate.RATE_24_32000]: 32_000,
  [ESamplingRate.RATE_15_25600]: 25_600,
  [ESamplingRate.RATE_23_16000]: 16_000,
  [ESamplingRate.RATE_14_12800]: 12_800,
  [ESamplingRate.RATE_22_8000]: 8_000,
  [ESamplingRate.RATE_13_6400]: 6_400,
  [ESamplingRate.RATE_21_4000]: 4_000,
  [ESamplingRate.RATE_12_3200]: 3_200,
  [ESamplingRate.RATE_20_2000]: 2_000,
  [ESamplingRate.RATE_11_1600]: 1_600,
  [ESamplingRate.RATE_19_1000]: 1_000,
  [ESamplingRate.RATE_10_800]: 800,
  [ESamplingRate.RATE_18_500]: 500,
  [ESamplingRate.RATE_09_400]: 400,
  [ESamplingRate.RATE_08_200]: 200,
  [ESamplingRate.RATE_07_100]: 100,
  [ESamplingRate.RATE_06_50]: 50,
  [ESamplingRate.RATE_05_25]: 25,
  [ESamplingRate.RATE_04_12]: 12,
  [ESamplingRate.RATE_04_6_25]: 6.25,
  [ESamplingRate.RATE_02_3_125]: 3.125,
  [ESamplingRate.RATE_01_1_563]: 1.563,
  [ESamplingRate.RATE_00_0_781]: 0.781
}
